import React, { useState, useEffect } from "react";
import "../../css/Settings.css";
import SettingProfilePic from "../../assets/Images/SettingProfilePic.png";
import SettingsChangePictureIcon from "../../assets/Icons/SettingsChangePictureIcon.svg";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { formatDate } from "../../helpers/DateHelpers";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";

const Settings = () => {
  const [noData, setNoData] = useState(false);
  const [userData, setUserData] = useState([]);
  const [lastLoginDate, setLastLoginDate] = useState("N/A");
  const [loading, setLoading] = useState(true);
  const loggedInUserName = sessionStorage.getItem("username");
  const { user } = useSelector((state) => state.auth);
  console.log("user", user);

  useEffect(() => {
    const storedLoginTime = sessionStorage.getItem("loginTime");
    fetchUserData();
    if (storedLoginTime) {
      setLastLoginDate(formatDate(storedLoginTime)); // Use the helper function
    }
  }, []);

  const fetchUserData = () => {
    const requestBody = {
      username: loggedInUserName,
      userId: loggedInUserName,
      status: "",
    };

    axiosPostApi(apiList.FETCH_USER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.data) {
          setUserData(response?.data?.data[0]);
        } else {
          if (
            response.data.respCode !== "01" &&
            response?.data?.data !== null
          ) {
            CustomAlert({
              title: "Failed to Fetch Data",
              text:
                response.data.message ||
                "No data available for the specified criteria.",
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setLoading(false);
      });
  };

  return (
    <div className="container">
      {loading && <Loader />}
      <div className="card p-4" style={{ fontSize: "14px" }}>
        <div className="row" style={{ alignItems: "center" }}>
          {/* Profile Picture and Basic Info */}
          <div
            className="col-md-3 text-center basic-info"
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* <img
              // src="https://via.placeholder.com/100"
              src={SettingProfilePic}
              alt="Profile"
              className="rounded-circle"
              width="100"
              height="100"
            /> */}

            <div style={{ textAlign: "left", marginBottom: "10px" }}>
              <h5 className="mt-3 settings-profile-details font-medium text-lg">
                {" "}
                {userData.name || "N/A"}{" "}
              </h5>
              {/* <p className="title-email" style={{margin: 0}}> {userData.emailId || 'N/A'} </p>
            <p style={{margin: 0}}> {userData.mobileNo || 'N/A'} </p> */}
            </div>
          </div>

          {/* Change Picture Button */}
          {/* <div className="col-md-9 text-end">
            <button className="btn btn-outline-info change-picture">
              <i className="bi bi-camera"></i> Change Picture
              <img src={SettingsChangePictureIcon} alt="Camera Icon" />
            </button>
          </div> */}
        </div>

        <hr />

        {/* Personal Information Section */}
        <h6 className="text-primary mb-3 mt-3 font-medium text-lg">Personal Information</h6>

        <div className="row">
          {/* Left Column */}
          <div className="col-md-4 mb-3">
            <p className="mb-3">
              Company Id: <br /> <strong> {userData.userCode || "N/A"} </strong>
            </p>
            <p className="mb-3">
              User Profile: <br />{" "}
              <strong> {userData.userProfile || "N/A"} </strong>
            </p>
            <p className="mb-3">
              User Role: <br />{" "}
              <strong> {userData.roleName || "N/A"} </strong>
            </p>
            <p className="mb-3">
              User Contact No: <br />{" "}
              <strong> {userData.mobileNo || "N/A"} </strong>
            </p>
          </div>

          {/* Middle Column */}
          <div className="col-md-4 mb-3">
            <p className="mb-3">
              Company Name: <br />{" "}
              <strong> {userData.customerName || "N/A"} </strong>
            </p>
            <p className="mb-3">
              User Status: <br />{" "}
              <strong
                style={{
                  color:
                    userData.authStatus === "ACTIVE" ? "#55cd69" : "#fb4a3f",
                }}
              >
                {" "}
                {userData.authStatus || "N/A"}{" "}
              </strong>
            </p>
            <p className="mb-3">
              SMS Rate (Transactional): <br />{" "}
              <strong> {userData.rate || "N/A"} </strong>
            </p>
          </div>

          {/* Right Column */}
          <div className="col-md-4 mb-3">
            <p className="mb-3">
              User Id: <br /> <strong> {userData.userId || "N/A"} </strong>
            </p>
            <p className="mb-3">
              User Email Id: <br />{" "}
              <strong> {userData.emailId || "N/A"} </strong>
            </p>
            <p className="mb-3">
              RCS Rate: <br /> <strong> {userData.rcsRate || "N/A"} </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
